// test2682
(2682 && 0);
